export default __webpack_public_path__ + "static/media/light-loader.77d19fdb.gif";